import React from "react";
import "./AboutPage.css";

import about1 from "../../Assets/About/about-1.jpg";
import about2 from "../../Assets/About/about-2.jpg";

import Services from "../../Components/Home/Services/Services";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

// import brand1 from "../../Assets/Brands/brand1.png";
// import brand2 from "../../Assets/Brands/brand2.png";
// import brand3 from "../../Assets/Brands/brand3.png";
// import brand4 from "../../Assets/Brands/brand4.png";
// import brand5 from "../../Assets/Brands/brand5.png";
// import brand6 from "../../Assets/Brands/brand6.png";
// import brand7 from "../../Assets/Brands/brand7.png";

const AboutPage = () => {
  return (
    <>
      <div className="aboutSection">
        <h2>Your Health, Our Mission. Welcome to SwasthMitra</h2>
        <div className="aboutContent">
          <p>
            At <strong>SwasthMitra</strong>, we're more than just an online pharmacy — we're your <strong>trusted partner in health</strong>. Just like the name says, we're your Mitra (friend) in your journey towards better health and well-being.
          </p>
          <p>
            We started SwasthMitra with one simple vision: <strong>make healthcare easy, affordable, and trustworthy for everyone.</strong>
          </p>
          <p>
            Whether you're managing a chronic condition, buying your monthly medicines, or simply stocking up your home first-aid — we make sure you get <strong>100% genuine medicines</strong>, delivered right to your doorstep, without hassle.
          </p>
          
          <h3>Why SwasthMitra?</h3>
          
          <div className="content1">
            <div className="contentBox">
              <h5>✅ Only Genuine Medicines</h5>
              <p>Sourced from licensed distributors and trusted brands. No compromises, ever.</p>
            </div>
            <div className="contentBox">
              <h5>🚚 Fast & Reliable Delivery</h5>
              <p>Your health can't wait. We ensure timely delivery across India, even to remote pin codes.</p>
            </div>
          </div>
          
          <div className="content1">
            <div className="contentBox">
              <h5>💸 Affordable Prices</h5>
              <p>Healthcare shouldn't be a luxury. We offer competitive pricing, discounts, and wallet-friendly deals.</p>
            </div>
            <div className="contentBox">
              <h5>🩺 Health Experts on Call</h5>
              <p>Need help with prescriptions? Our certified pharmacists and support team are always ready to assist.</p>
            </div>
          </div>
          
          <div className="contentBox">
            <h5>❤ People First</h5>
            <p>Our mission is to serve. Every order, every call, every message — we treat it with care, like family.</p>
          </div>
          
          <p>
            We believe that good health begins with <strong>trust</strong>, and trust begins with transparency and care. That's why thousands choose SwasthMitra — not just for the medicines, but for the peace of mind.
          </p>
        </div>
      </div>
      <Services />
      {/* <div className="companyPartners">
        <h5>Company Partners</h5>
        <Swiper
          slidesPerView={1}
          loop={true}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 5,
            },

            768: {
              slidesPerView: 4,
              spaceBetween: 40,
            },

            1024: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
          }}
          spaceBetween={10}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
        >
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand1} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand2} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand3} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand4} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand5} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand6} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand7} alt="" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div> */}
    </>
  );
};

export default AboutPage;